/** Fixed Jalali occasions (Iran national / cultural). Lunar Islamic dates omitted. */

export interface JalaliOccasion {
  readonly month: number;
  readonly day: number;
  readonly title: string;
  readonly isHoliday?: boolean;
}

export const JALALI_OCCASIONS: readonly JalaliOccasion[] = [
  { month: 1, day: 1, title: 'آغاز نوروز', isHoliday: true },
  { month: 1, day: 2, title: 'تعطیلات نوروز', isHoliday: true },
  { month: 1, day: 3, title: 'تعطیلات نوروز', isHoliday: true },
  { month: 1, day: 4, title: 'تعطیلات نوروز', isHoliday: true },
  { month: 1, day: 12, title: 'روز جمهوری اسلامی', isHoliday: true },
  { month: 1, day: 13, title: 'سیزده‌به‌در', isHoliday: true },
  { month: 3, day: 14, title: 'رحلت امام خمینی', isHoliday: true },
  { month: 3, day: 15, title: 'قیام ۱۵ خرداد', isHoliday: true },
  { month: 4, day: 7, title: 'روز قوه قضاییه' },
  { month: 5, day: 16, title: 'سالروز تشکیل جهاد دانشگاهی' },
  { month: 6, day: 1, title: 'روز پزشک' },
  { month: 7, day: 13, title: 'جشن مهرگان' },
  { month: 8, day: 10, title: 'روز ملی فرش' },
  { month: 9, day: 16, title: 'روز دانشجو' },
  { month: 10, day: 30, title: 'شب یلدا' },
  { month: 11, day: 22, title: 'پیروزی انقلاب اسلامی', isHoliday: true },
  { month: 12, day: 15, title: 'روز درختکاری' },
  { month: 12, day: 29, title: 'روز ملی شدن صنعت نفت', isHoliday: true },
];

export function occasionsFor(month: number, day: number): readonly JalaliOccasion[] {
  return JALALI_OCCASIONS.filter((o) => o.month === month && o.day === day);
}
